var _circle, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFooterIconTw(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 32,
    viewBox: "0 0 33 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 16.9258,
    cy: 16,
    r: 16,
    fill: "#D9F5EE"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_126_1977)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M26.7704 9.89412C26.0381 10.2153 25.2578 10.4283 24.4443 10.5317C25.2812 10.032 25.92 9.24673 26.2203 8.30027C25.44 8.7655 24.5784 9.09412 23.6603 9.2775C22.9194 8.48858 21.8634 7.99996 20.7114 7.99996C18.4763 7.99996 16.6769 9.81412 16.6769 12.0381C16.6769 12.3581 16.704 12.6658 16.7704 12.9587C13.4141 12.795 10.4443 11.1864 8.4492 8.73596C8.10089 9.34027 7.89659 10.032 7.89659 10.7766C7.89659 12.1747 8.61659 13.4141 9.68982 14.1317C9.0412 14.1193 8.40489 13.931 7.86582 13.6344C7.86582 13.6467 7.86582 13.6627 7.86582 13.6787C7.86582 15.6406 9.2652 17.2701 11.1003 17.6455C10.7717 17.7353 10.4135 17.7784 10.0418 17.7784C9.78336 17.7784 9.52243 17.7637 9.27751 17.7095C9.80059 19.3083 11.2849 20.4837 13.0498 20.5218C11.6763 21.5963 9.93228 22.2437 8.04428 22.2437C7.7132 22.2437 7.39566 22.2289 7.07812 22.1883C8.86643 23.3415 10.9858 24 13.2714 24C20.7003 24 24.7618 17.8461 24.7618 12.512C24.7618 12.3335 24.7557 12.1612 24.747 11.9901C25.5483 11.4215 26.2215 10.7113 26.7704 9.89412Z",
    fill: "#252A34"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_126_1977"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 19.6923,
    height: 19.6923,
    fill: "white",
    transform: "translate(7.07812 6.15381)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFooterIconTw);
export default __webpack_public_path__ + "static/media/FooterIconTw.8967277248e6e549cbe33c08e5d73c99.svg";
export { ForwardRef as ReactComponent };